import keyBy from 'lodash/keyBy';
import uniqBy from 'lodash/uniqBy';

import { parseFormDataFunction } from '@/modules/corporate/modules/database/fields/types';
import { FieldType } from '@/modules/corporate/modules/database/interfaces';
import { DocumentFieldsInput, EntityCollectionEnum, PerformanceTypeEnum } from '@/types/schema';

const addParentContentRelationData = (parentContentId: string): DocumentFieldsInput[] => [
  {
    fieldId: 'parentContent',
    data: {
      value: parentContentId,
      metadata: {
        r: {
          type: PerformanceTypeEnum.Course,
          collectionName: EntityCollectionEnum.Resource,
        },
      },
    },
  },
];

interface Params {
  parentContentId?: string;
  values: any;
  fields: FieldType[];
}

const defaultParseFormData: parseFormDataFunction = (value) => ({ value });

const parseSurveyFormValues = (params: Params) => {
  const { values, fields, parentContentId } = params;
  const fieldsById = keyBy(fields, 'metadataField.fieldId');

  const fieldsData: DocumentFieldsInput[] = [];
  const initialValues: any = {};

  if (parentContentId) {
    fieldsData.push(...addParentContentRelationData(parentContentId));
  }

  Object.entries<string>(values).forEach(([fieldId, value]) => {
    const field = fieldsById[fieldId];
    if (!field) {
      return;
    }
    const parseFormData = field.config.Viewer.parseFormData || defaultParseFormData;
    const data = parseFormData(value, field);
    fieldsData.push({ fieldId, data });
    initialValues[fieldId] = data;
  });

  return { fieldsData: uniqBy(fieldsData, 'fieldId'), initialValues };
};

export default parseSurveyFormValues;
